import BasePage from "../base-page";
class ProductCard extends HTMLElement {
  static DEFAULT_CART_ICON = `
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="34" viewBox="0 0 31 34" fill="none">
      <path d="M14.3177 30.7024H8.09314C6.957 30.7023 5.85841 30.2956 4.99615 29.5558C4.1339 28.816 3.56495 27.7919 3.39226 26.669L1.40251 13.7443C1.33301 13.2924 1.36206 12.8309 1.48765 12.3913C1.61325 11.9517 1.83242 11.5444 2.13015 11.1975C2.42787 10.8505 2.7971 10.572 3.21253 10.3811C3.62796 10.1902 4.07976 10.0914 4.53696 10.0914H22.5145C22.9717 10.0914 23.4235 10.1902 23.8389 10.3811C24.2543 10.572 24.6236 10.8505 24.9213 11.1975C25.219 11.5444 25.4382 11.9517 25.5638 12.3913C25.6894 12.8309 25.7184 13.2924 25.6489 13.7443L25.232 16.4523M19.8668 27.5315H29.3795M24.6231 22.7751V32.2879" stroke="white" stroke-width="2.57355" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8.76849 14.8461V6.91885C8.76849 5.65738 9.26961 4.44758 10.1616 3.55559C11.0536 2.66359 12.2634 2.16248 13.5249 2.16248C14.7863 2.16248 15.9961 2.66359 16.8881 3.55559C17.7801 4.44758 18.2812 5.65738 18.2812 6.91885V14.8461" stroke="white" stroke-width="2.57355" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;
  static outOfStock_icon = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 1024 1024" fill="white" style="fill: currentColor;"><path d="M704 288h131.072a32 32 0 0 1 31.808 28.8L886.4 512h-64.384l-16-160H704v96a32 32 0 1 1-64 0v-96H384v96a32 32 0 0 1-64 0v-96H217.92l-51.2 512H512v64H131.328a32 32 0 0 1-31.808-35.2l57.6-576a32 32 0 0 1 31.808-28.8H320v-22.336C320 154.688 405.504 64 512 64s192 90.688 192 201.664v22.4zm-64 0v-22.336C640 189.248 582.272 128 512 128s-128 61.248-128 137.664v22.4h256zm201.408 476.16a32 32 0 1 1 45.248 45.184l-128 128a32 32 0 0 1-45.248 0l-128-128a32 32 0 1 1 45.248-45.248L704 837.504V608a32 32 0 1 1 64 0v229.504l73.408-73.408z"/></svg>  `;
  constructor() {
    super();
  }

  connectedCallback() {
    // Parse product data
    this.product = this.product || JSON.parse(this.getAttribute("product"));
    if (this.product.is_out_of_stock && wing.is_hiddnoutofstock == "true") {
      this.remove();
      return;
    }
    if (window.app?.status === "ready") {
      this.onReady();
    } else {
      document.addEventListener("theme::ready", () => this.onReady());
    }
  }

  onReady() {
    this.fitImageHeight = salla.config.get("store.settings.product.fit_type");
    this.placeholder = salla.url.asset(
      salla.config.get("theme.settings.placeholder"),
    );
    this.getProps();

    this.source = salla.config.get("page.slug");
    if (this.source == "landing-page") {
      this.hideAddBtn = true;
      this.showQuantity = window.showQuantity;
    }

    salla.lang.onLoaded(() => {
      // Language
      this.remained = salla.lang.get("pages.products.remained");
      this.donationAmount = salla.lang.get("pages.products.donation_amount");
      this.startingPrice = salla.lang.get("pages.products.starting_price");
      this.addToCart = salla.lang.get("pages.cart.add_to_cart");
      this.outOfStock = salla.lang.get("pages.products.out_of_stock");

      // re-render to update translations
      this.render();
    });

    this.render();
  }
  getDiscount() {
    let { sale_price: _, regular_price: $ } = this.product;
    return _ && $ && !($ <= _)
      ? `<div class="absolute bottom-2 left-2 text-xxs text-white px-2 py-1 rounded-full flex justify-center items-center gap-x-1 text-sm animate-pulse-shadow"
        style="background-color: rgb(22, 163, 74); border: 1px solid rgb(22, 163, 74); animation: shadow-pulse 2s infinite;">
        <i class="sicon-check-circle"></i>
        <b class="inline-block leading-none">
          ${salla.lang.get("pages.products.discountma")} ${Math.round((($ - _) / $) * 100)}%
        </b>
      </div>
      `
      : "";
  }
  getPriceFormat(price) {
    if (!price || price == 0) {
      return salla.config.get("store.settings.product.show_price_as_dash")
        ? "-"
        : "";
    }
    return salla.money(price);
  }
  getProductPrice() {
    let price = "";
    if (this.product.is_on_sale) {
      price = `<div class="s-product-card-sale-price">
                <h4 class="s-product-card-sale-price">${this.getPriceFormat(this.product.sale_price)}</h4>
                <span class="s-product-card-sale-price">${this.getPriceFormat(this.product?.regular_price)}</span>
              </div>`;
    } else if (this.product.starting_price) {
      price = `<div class="s-product-card-starting-price">
                  <p class="s-product-card-price">${this.startingPrice}</p>
                  <h4 class="s-product-card-sale-price"> ${this.getPriceFormat(this.product?.starting_price)} </h4>
              </div>`;
    } else {
      price = `<h4 class="s-product-card-price">${this.getPriceFormat(this.product?.price)}</h4>`;
    }
    return price;
  }
  updateOptionsCart() {
    const hasOptionsCart =
      wing.has_options_cart === true || wing.has_options_cart === "true";
    if (!hasOptionsCart && !this.nooption) return;
    if (this.querySelector("salla-product-options")) return;

    const container = this.querySelector(".s-product-card-options");
    if (!container) return;

    const prodOptions = document.createElement("salla-product-options");
    let config = {};
    if (window.show_singleOption) config["single-option"] = { type: "button" };
    if (window.show_multipleOption)
      config["multiple-option"] = { type: "button" };

    prodOptions.setAttribute("config", JSON.stringify(config));
    prodOptions.setAttribute("options", JSON.stringify(this.product.options));
    prodOptions.setAttribute("product-id", `${this.product.id}`);

    prodOptions.addEventListener("changed", () => {
      const form = prodOptions.closest("form");

      salla.event.once("product::price.updated", (event, productId) => {
        if (productId === this.product.id) {
          this.updateInnerPrice(event);
        }
      });

      salla.event.once("product::price.updated.failed", (_, productId) => {
        if (productId === this.product.id) {
          console.warn("Price update failed for product:", productId);
        }
      });

      if (form) {
        salla.product.getPrice(new FormData(form));
      }
    });

    // شيل اللودر واضف العنصر
    container.innerHTML = "";
    container.appendChild(prodOptions);
  }

  updateInnerPrice(response) {
    const data = response.data;
    const newPrice = data.price;
    const regularPrice = data.regular_price;
    const isOnSale = data.has_sale_price && regularPrice > newPrice;
    const salePriceEl = this.querySelector("h4.s-product-card-sale-price");
    const regularPriceEl = this.querySelector("span.s-product-card-sale-price");
    const priceBefore = this.querySelector(".s-product-card-price-before");
    const normalPriceEls = this.querySelectorAll(".s-product-card-price");
    const startingBox = this.querySelector(".s-product-card-starting-price");
    if (startingBox) startingBox.classList.add("hidden");
    this.querySelector(".s-product-card-content-sub")?.classList.remove(
      "hidden",
    );
    normalPriceEls.forEach((el) => {
      el.classList.remove("scale-in");
      void el.offsetWidth;
      el.innerHTML = this.getPriceFormat(newPrice);
      el.classList.add("scale-in");
    });
    if (salePriceEl && regularPriceEl) {
      salePriceEl.classList.remove("scale-in");
      regularPriceEl.classList.remove("scale-in");
      void salePriceEl.offsetWidth;
      void regularPriceEl.offsetWidth;
      salePriceEl.innerHTML = this.getPriceFormat(newPrice);
      regularPriceEl.innerHTML = this.getPriceFormat(regularPrice);
      salePriceEl.classList.add("scale-in");
      regularPriceEl.classList.add("scale-in");
    }
    if (priceBefore) {
      priceBefore.classList.remove("scale-in");
      void priceBefore.offsetWidth;
      priceBefore.innerHTML = this.getPriceFormat(regularPrice);
      priceBefore.classList.add("scale-in");
    }
    const saleContainer = this.querySelector(".s-product-card-sale-price");
    if (saleContainer) {
      saleContainer.classList.toggle("hidden", !isOnSale);
    }
  }
  formatDate(timestampInSeconds) {
    let d = new Date(timestampInSeconds * 1000);
    return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
  }
  getProductBadge() {
    if (this.product.promotion_title) {
      return `<div class="s-product-card-promotion-title">${this.product.promotion_title}</div>`;
    }
    if (this.showQuantity && this.product?.quantity) {
      return `<div
        class="s-product-card-quantity">${this.remained} ${salla.helpers.number(this.product?.quantity)}</div>`;
    }
    if (this.showQuantity && this.product?.is_out_of_stock) {
      return `<div class="s-product-card-out-badge">${this.outOfStock}</div>`;
    }
    return "";
  }
  getAddButtonLabel() {
    if (this.product.status === "sale" && this.product.type === "booking") {
      return salla.lang.get("pages.cart.book_now");
    }
    if (this.product.status === "sale") {
      return salla.lang.get("pages.cart.add_to_cart");
    }
    if (this.product.type !== "donating") {
      return `${wing.style_btn_card == "full_width_under_content" || wing.style_btn_card == "full_width_bottom" ? `` : `${ProductCard.outOfStock_icon}`}`;
    }
    return salla.lang.get("pages.products.donation_exceed");
  }

  getProps() {
    this.horizontal = this.hasAttribute("horizontal");
    this.shadowOnHover = this.hasAttribute("shadowOnHover");
    this.hideAddBtn = this.hasAttribute("hideAddBtn");
    this.fullImage = this.hasAttribute("fullImage");
    this.minimal = this.hasAttribute("minimal");
    this.isSpecial = this.hasAttribute("isSpecial");
    this.showQuantity = this.hasAttribute("showQuantity");
    this.nooption = this.hasAttribute("nooption");
  }

  render() {
    this.setAttribute("id", this.product.id);
    const dynamicClasses = [
      !this.horizontal && !this.fullImage && !this.minimal
        ? "s-product-card-vertical"
        : "",
      this.horizontal && !this.fullImage && !this.minimal
        ? "s-product-card-horizontal"
        : "",
      this.fitImageHeight && !this.isSpecial && !this.fullImage && !this.minimal
        ? "s-product-card-fit-height"
        : "",
      this.isSpecial ? "s-product-card-special" : "",
      this.fullImage ? "s-product-card-full-image" : "",
      this.minimal ? "s-product-card-minimal" : "",
      this.product?.donation ? "s-product-card-donation" : "",
      this.shadowOnHover ? "s-product-card-shadow" : "",
      this.product?.is_out_of_stock ? "s-product-card-out-of-stock" : "",
    ]
      .filter(Boolean)
      .join(" ");
    this.isInWishlist =
      !salla.config.isGuest() &&
      salla.storage.get("salla::wishlist", []).includes(this.product.id);
    this.effectiveStatus =
      this.product.is_out_of_stock &&
      window.notify_when_available_in_card &&
      !["donating", "financial_support"].includes(this.product?.type)
        ? "out-and-notify"
        : this.product.status;
    this.innerHTML = `
    <form class="${!this.horizontal ? "Wvr" : "Whr"} h-full w-full donating-wrap form product-form ${wing.is_gridiant == " true" ? "gridiant_product" : ""}" enctype="multipart/form-data" method="post" onchange="salla.product.getPrice(new FormData(event.currentTarget))" onsubmit="return salla.form.onSubmit('cart.addItem', event)">
      <div class=" ${wing.is_padding == " true" ? "p-1.5" : ""} s-product-card-entry ${dynamicClasses}">
        <div class="${!this.fullImage ? "s-product-card-image" : "s-product-card-image-full"}">
          <a href="${this.product?.url}" class="relative">
              <img id="product-img-${this.product.id}" 
       class="s-product-card-image-${
         salla.url.is_placeholder(this.product?.image?.url)
           ? "contain"
           : this.fitImageHeight
             ? this.fitImageHeight
             : "cover"
       } " 
       src="${this.placeholder}" 
       alt="${this.product?.image?.alt || this.product?.name}" 
       width="500" height="500" loading="lazy"
       style="opacity: 0;" />
  <span class="loading_image flex-center"><span class="ld"></span></span>

            ${!this.fullImage && !this.minimal ? this.getProductBadge() : ""}
          </a>
          ${
            wing.style_btn_card != "bottom_icons"
              ? `
            <div class="obts">
              ${
                wing.has_q_view == "true"
                  ? `<salla-button class="Mws_opsbtn_eye" loader-position="center" shape="icon" fill="outline" color="light" name="product-name-${this.product.id}" onclick="handleOpenQuek(${this.product.id})">
                <i class="sicon-vision"></i>
                <span class="tooltip">${salla.lang.get("pages.products.vuick_view")}</span>
              </salla-button>`
                  : ``
              }
              <salla-button shape="icon" fill="outline" color="light" id="card-wishlist-btn-${this.product.id}-horizontalf" name="product-name-${this.product.id}" aria-label="Add or remove to wishlist" class="animated ${this.isInWishlist ? "s-product-card-wishlist-added pulse-anime" : "not-added un-favorited"}" onclick="salla.wishlist.toggle(${this.product.id})" data-id="${this.product.id}">
                <i class="sicon-heart"></i>
                <span class="tooltip">${salla.lang.get("pages.products.add_to_wishlist")}</span>
              </salla-button>
              ${
                wing.has_rel_pro == "true"
                  ? `
                <salla-button class="Mws_opsbtn_rel" loader-position="center" shape="icon" fill="outline" color="light" name="product-related-name-${this.product.id}" onclick="handleOpenRelated(${this.product.id})">
                  <i class="sicon-switch-flip"></i>
                  <span class="tooltip">${salla.lang.get("pages.products.related_products")}</span>
                </salla-button>
              `
                  : ``
              }
              ${
                wing.style_btn_card == "on_image_icons"
                  ? `
<salla-add-product-button
  fill="outline"
  width="wide"
  ${wing.has_options_cart == "true" && this.product.has_options && !this.nooption ? 'type="submit"' : ""}
  product-id="${this.product.id}"
  shape="icon"
  product-status="${this.effectiveStatus}"
  product-type="${this.product.type}"
  aria-label="${this.product.add_to_cart_label ? this.product.add_to_cart_label : "أضف إلى السلة"}">

  ${
    this.product.status == "sale"
      ? `${
          wing.product_cart_icon == "def"
            ? ProductCard.DEFAULT_CART_ICON
            : `<i class="text-base ${wing.product_cart_icon}"></i>`
        }`
      : `${this.getAddButtonLabel()}`
  }

  <span class="tooltip">${this.product.status == "sale" ? this.product.add_to_cart_label : this.outOfStock}</span>
</salla-add-product-button>

              `
                  : ``
              }
            </div>
          `
              : ``
          }
          ${wing.show_descound == "true" ? this.getDiscount() : ""}
               ${wing.add_original == "true" ? `<div class="original"><svg viewBox="0 0 24 24" fill="#ffffff" xmlns="http://www.w3.org/2000/svg"><g><path class="blue" d="M22.25 12c0-1.43-.88-2.67-2.19-3.34.46-1.39.2-2.9-.81-3.91s-2.52-1.27-3.91-.81c-.66-1.31-1.91-2.19-3.34-2.19s-2.67.88-3.33 2.19c-1.4-.46-2.91-.2-3.92.81s-1.26 2.52-.8 3.91c-1.31.67-2.2 1.91-2.2 3.34s.89 2.67 2.2 3.34c-.46 1.39-.21 2.9.8 3.91s2.52 1.26 3.91.81c.67 1.31 1.91 2.19 3.34 2.19s2.68-.88 3.34-2.19c1.39.45 2.9.2 3.91-.81s1.27-2.52.81-3.91c1.31-.67 2.19-1.91 2.19-3.34zm-11.71 4.2L6.8 12.46l1.41-1.42 2.26 2.26 4.8-5.23 1.47 1.36-6.2 6.77z"></path></g></svg></div>` : ``}
          ${this.fullImage ? `<a href="${this.product?.url}" aria-label=${this.product.name} class="s-product-card-overlay"></a>` : ""}
        </div>
        <div class="fg s-product-card-content-main p-1.5 w-full ${this.isSpecial ? "s-product-card-content-extra-padding" : ""}">
          <div class="flex flex-col">
            ${
              wing.show_countdoune == "true"
                ? `
              ${
                this.product.discount_ends
                  ? `<salla-count-down date="${this.formatDate(this.product.discount_ends)}" end-of-day=${true} boxed=${true}
                    labeled=${true} >`
                  : ``
              }
            `
                : ``
            }
            <div class="center-between">
              ${this.product.category?.name && wing.has_category == "true" ? `<a href="${this.product.category?.url}" class=" text-xs p-1 leading-none rounded-sm">${this.product.category?.name}</a>` : ""}
              ${
                this.product
                  ? ` <div class="s-product-card-rating">
                <i class="sicon-star2 before:text-orange-500"></i>
                <span>5</span>
              </div>`
                  : ``
              }
            </div>
          </div>
          <h2 class="s-product-card-content-title">
            <a href="${this.product?.url}">${this.product?.name}</a>
          </h2>
          ${
            this.product?.subtitle &&
            !this.minimal &&
            wing.none_subtitle == "false"
              ? `<p class="s-product-card-content-subtitle opacity-80">${this.product?.subtitle}</p>`
              : ``
          }
          <div class="fg">
            ${
              wing.show_card_tags == "true" && this.product.tags?.length
                ? `
              <div class="tags ts">
                ${this.product.tags.map((tag) => `<a href="${tag.url}">#${tag.name}</a>`).join("")}
                ${
                  wing.style_btn_card == "on_image_tags"
                    ? `
                  ${
                    !this.product?.quantity &&
                    wing.show_available_pieces == "true"
                      ? `
                    <span class="ts">
                      ${this.remained} (${salla.helpers.number(this.product?.quantity)})
                    </span>
                  `
                      : ``
                  }
                `
                    : ``
                }
              </div>
            `
                : ""
            }
            <div class="center-between ">
              ${this.product?.donation?.can_donate ? "" : this.getProductPrice()}
              ${
                wing.style_btn_card == "next_to_price" ||
                wing.style_btn_card == "next_to_price_outside"
                  ? `
              <salla-add-product-button
  fill="outline"
  width="wide"
  class="iconglow ${wing.style_btn_card === "next_to_price_outside" ? (wing.is_padding === "true" ? "-translate-x-7" : "translate-x-5") : ""}"
  ${wing.has_options_cart == "true" && !this.nooption && this.product.has_options ? 'type="submit"' : ""}
  product-id="${this.product.id}"
  shape="icon"
  product-status="${this.product.status}"
  product-type="${this.product.type}"
  aria-label="${this.product.add_to_cart_label ? this.product.add_to_cart_label : "أضف إلى السلة"}">

  ${
    this.product.status == "sale"
      ? `${
          wing.product_cart_icon == "def"
            ? ProductCard.DEFAULT_CART_ICON
            : `<i class="text-base ${wing.product_cart_icon}"></i>`
        }`
      : `${this.getAddButtonLabel()}`
  }

</salla-add-product-button>

              `
                  : `
                ${
                  !this.product?.quantity &&
                  wing.show_available_pieces == "true"
                    ? `
                  <span class="ts">
                    ${this.remained} (${salla.helpers.number(this.product?.quantity)})
                  </span>
                `
                    : ``
                }
              `
              }
            </div>
          </div>
          ${
            this.product?.donation && !this.minimal && !this.fullImage
              ? `<salla-progress-bar donation=${JSON.stringify(this.product?.donation)}></salla-progress-bar>
            <div class="s-product-card-donation-input">
              ${
                this.product?.donation?.can_donate
                  ? `<label for="donation-amount-${this.product.id}">${this.donationAmount} <span>*</span></label>
                <input
                  type="text"
                  onInput="${(e) => {
                    salla.helpers.inputDigitsOnly(e.target);
                    this.addBtn.donatingAmount = e.target.value;
                  }}"
                  id="donation-amount-${this.product.id}"
                  name="donating_amount"
                  class="s-form-control"
                  placeholder="${this.donationAmount}" />`
                  : ``
              }
            </div>`
              : ""
          }
          <div class="s-product-card-content-sub fg">
            ${
              wing.has_options_cart == "true" &&
              this.product.has_options &&
              !this.nooption
                ? `<div><input type="hidden" name="id" value="${this.product.id}">
              <input type="hidden" name="quantity" value="1"><div class="s-product-card-options"><span id="pro_spinner" class="s-button-loader block mx-auto my-4"></span></div></div>`
                : ""
            }
            ${
              !this.hideAddBtn
                ? `<div class="s-product-card-content-footer gap-2 w-full">
                ${
                  wing.style_btn_card == "full_width_bottom"
                    ? `<salla-add-product-button
  fill="outline"
  width="wide"
  ${wing.has_options_cart == "true" && this.product.has_options && !this.nooption ? 'type="submit"' : ""}
  product-id="${this.product.id}"
  class="fl_bt"
  product-status="${this.product.status}"
  product-type="${this.product.type}"
  aria-label="${this.product.add_to_cart_label ? this.product.add_to_cart_label : this.getAddButtonLabel()}">

  ${
    this.product.status == "sale"
      ? `${
          wing.product_cart_icon == "def"
            ? ProductCard.DEFAULT_CART_ICON
            : `<i class="text-base ${wing.product_cart_icon}"></i>`
        }`
      : `${this.getAddButtonLabel()}`
  }

  <span>${this.product.add_to_cart_label ? this.product.add_to_cart_label : this.getAddButtonLabel()}</span>
</salla-add-product-button>
`
                    : ``
                }
              
              </div>`
                : ``
            }
          </div>
          ${
            wing.style_btn_card == "bottom_icons" && this.horizontal
              ? `
      <div class="bottom_icons">
          <div class="obts">
            <salla-add-product-button
    fill="outline"
    width="wide"
    class="iconglow ${wing.style_btn_card === "next_to_price_outside" ? (wing.is_padding === "true" ? "-translate-x-7" : "translate-x-5") : ""}"
    ${wing.has_options_cart == "true" && this.product.has_options && !this.nooption ? 'type="submit"' : ""}
    product-id="${this.product.id}"
    shape="icon"
    product-status="${this.product.status}"
    product-type="${this.product.type}"
    aria-label="${this.product.add_to_cart_label ? this.product.add_to_cart_label : "أضف إلى السلة"}">
  
    ${
      this.product.status == "sale"
        ? `${
            wing.product_cart_icon == "def"
              ? ProductCard.DEFAULT_CART_ICON
              : `<i class="text-base ${wing.product_cart_icon}"></i>`
          }`
        : `${this.getAddButtonLabel()}`
    }
  
  </salla-add-product-button>
  
            ${
              wing.has_q_view == "true"
                ? `<salla-button class="Mws_opsbtn_eye" loader-position="center" shape="icon" fill="outline" color="light" name="product-name-${this.product.id}" onclick="handleOpenQuek(${this.product.id})">
              <i class="sicon-vision"></i>
              <span class="tooltipb">${salla.lang.get("pages.products.vuick_view")}</span>
            </salla-button>`
                : ``
            }
            <salla-button shape="icon" fill="outline" color="light" id="card-wishlist-btn-${this.product.id}-horizontalf" name="product-name-${this.product.id}" aria-label="Add or remove to wishlist" class="animated ${this.isInWishlist ? "s-product-card-wishlist-added pulse-anime" : "not-added un-favorited"}" onclick="salla.wishlist.toggle(${this.product.id})" data-id="${this.product.id}">
              <i class="sicon-heart"></i>
              <span class="tooltipb">${salla.lang.get("pages.products.add_to_wishlist")}</span>
            </salla-button>
            ${
              wing.has_rel_pro == "true"
                ? `
              <salla-button class="Mws_opsbtn_rel" loader-position="center" shape="icon" fill="outline" color="light" name="product-related-name-${this.product.id}" onclick="handleOpenRelated(${this.product.id})">
                <i class="sicon-switch-flip"></i>
                <span class="tooltipb">${salla.lang.get("pages.products.related_products")}</span>
              </salla-button>
            `
                : ``
            }
          </div>
          </div>
          `
              : ``
          }
        </div>
        ${
          wing.style_btn_card == "full_width_under_content"
            ? `
          <salla-add-product-button
  fill="outline"
  width="wide"
  class="iconglow"
  ${wing.has_options_cart == "true" && this.product.has_options && !this.nooption ? 'type="submit"' : ""}
  product-id="${this.product.id}"
  product-status="${this.product.status}"
  product-type="${this.product.type}"
  aria-label="${this.product.add_to_cart_label ? this.product.add_to_cart_label : this.getAddButtonLabel()}">

  ${
    this.product.status == "sale"
      ? `${
          wing.product_cart_icon == "def"
            ? ProductCard.DEFAULT_CART_ICON
            : `<i class="text-base ${wing.product_cart_icon}"></i>`
        }`
      : `${this.getAddButtonLabel()}`
  }

  <span>${this.product.add_to_cart_label ? this.product.add_to_cart_label : `${this.getAddButtonLabel()}`}</span>
</salla-add-product-button>

        `
            : ``
        }


          ${
            wing.style_btn_card == "bottom_icons" && !this.horizontal
              ? `
      <div class="bottom_icons">
          <div class="obts">
            <salla-add-product-button
    fill="outline"
    width="wide"
    class="iconglow ${wing.style_btn_card === "next_to_price_outside" ? (wing.is_padding === "true" ? "-translate-x-7" : "translate-x-5") : ""}"
    ${wing.has_options_cart == "true" && this.product.has_options && !this.nooption ? 'type="submit"' : ""}
    product-id="${this.product.id}"
    shape="icon"
    product-status="${this.product.status}"
    product-type="${this.product.type}"
    aria-label="${this.product.add_to_cart_label ? this.product.add_to_cart_label : "أضف إلى السلة"}">
  
    ${
      this.product.status == "sale"
        ? `${
            wing.product_cart_icon == "def"
              ? ProductCard.DEFAULT_CART_ICON
              : `<i class="text-base ${wing.product_cart_icon}"></i>`
          }`
        : `${this.getAddButtonLabel()}`
    }
  </salla-add-product-button>
            ${
              wing.has_q_view == "true"
                ? `<salla-button class="Mws_opsbtn_eye" loader-position="center" shape="icon" fill="outline" color="light" name="product-name-${this.product.id}" onclick="handleOpenQuek(${this.product.id})">
              <i class="sicon-vision"></i>
              <span class="tooltipb">${salla.lang.get("pages.products.vuick_view")}</span>
            </salla-button>`
                : ``
            }
            <salla-button shape="icon" fill="outline" color="light" id="card-wishlist-btn-${this.product.id}-horizontalf" name="product-name-${this.product.id}" aria-label="Add or remove to wishlist" class="animated ${this.isInWishlist ? "s-product-card-wishlist-added pulse-anime" : "not-added un-favorited"}" onclick="salla.wishlist.toggle(${this.product.id})" data-id="${this.product.id}">
              <i class="sicon-heart"></i>
              <span class="tooltipb">${salla.lang.get("pages.products.add_to_wishlist")}</span>
            </salla-button>
            ${
              wing.has_rel_pro == "true"
                ? `
              <salla-button class="Mws_opsbtn_rel" loader-position="center" shape="icon" fill="outline" color="light" name="product-related-name-${this.product.id}" onclick="handleOpenRelated(${this.product.id})">
                <i class="sicon-switch-flip"></i>
                <span class="tooltipb">${salla.lang.get("pages.products.related_products")}</span>
              </salla-button>
            `
                : ``
            }
          </div>
          </div>
          `
              : ``
          }
      </div>
    
    </form>
  `;
    const img = this.querySelector(`#product-img-${this.product.id}`);
    const loader = this.querySelector(".loading_image");
    const realSrc = this.product?.image?.url || this?.product?.thumbnail;

    if (img && realSrc) {
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              img.onload = () => {
                if (loader) loader.remove();
                img.style.opacity = 1;
              };

              img.src = realSrc;
              this.updateOptionsCart();
              observer.unobserve(img);
            }
          });
        },
        {
          root: null,
          threshold: 0.1,
        },
      );

      observer.observe(img);
    }

    this.querySelectorAll('[name="donating_amount"]').forEach((element) => {
      element.addEventListener("input", (e) => {
        e.target
          .closest(".s-product-card-content")
          .querySelector("salla-add-product-button")
          .setAttribute("donating-amount", e.target.value);
      });
    });

    // Optimistic & Per-card wishlist toggle
    this.querySelectorAll(".s-product-card-wishlist-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        const willBeAdded = !btn.classList.contains(
          "s-product-card-wishlist-added",
        );
        app.toggleElementClassIf(
          btn,
          "s-product-card-wishlist-added",
          "not-added",
          () => willBeAdded,
        );
        app.toggleElementClassIf(
          btn,
          "pulse-anime",
          "un-favorited",
          () => willBeAdded,
        );
      });
    });

    document.lazyLoadInstance?.update(this.querySelectorAll(".lazy"));
  }
}

customElements.define("custom-salla-product-card", ProductCard);

window.handleOpenRelated = async function (productId) {
  const { openModelrelated } = await import("./modules.js");
  openModelrelated(productId);
};

window.handleOpenQuek = async function (productId) {
  const { openQuek } = await import("./modules.js");
  openQuek(productId);
};
